var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMaterialSymbolsPlayCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.5 17.0938L16.5 12.5938L9.5 8.09375V17.0938ZM12 22.5938C10.6167 22.5938 9.31667 22.3311 8.1 21.8057C6.88333 21.2811 5.825 20.5688 4.925 19.6688C4.025 18.7688 3.31267 17.7104 2.788 16.4937C2.26267 15.2771 2 13.9771 2 12.5938C2 11.2104 2.26267 9.91042 2.788 8.69375C3.31267 7.47708 4.025 6.41875 4.925 5.51875C5.825 4.61875 6.88333 3.90608 8.1 3.38075C9.31667 2.85608 10.6167 2.59375 12 2.59375C13.3833 2.59375 14.6833 2.85608 15.9 3.38075C17.1167 3.90608 18.175 4.61875 19.075 5.51875C19.975 6.41875 20.6873 7.47708 21.212 8.69375C21.7373 9.91042 22 11.2104 22 12.5938C22 13.9771 21.7373 15.2771 21.212 16.4937C20.6873 17.7104 19.975 18.7688 19.075 19.6688C18.175 20.5688 17.1167 21.2811 15.9 21.8057C14.6833 22.3311 13.3833 22.5938 12 22.5938Z",
    fill: "#8D78FB"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMaterialSymbolsPlayCircle);
export default __webpack_public_path__ + "static/media/material-symbols_play-circle.b49b43f50127551934a2288cf1a14769.svg";
export { ForwardRef as ReactComponent };